import bannerImageWide from 'shared/propsMocks/images/ad-slot-banner-wide.jpg'
import bannerImage from 'shared/propsMocks/images/ad-slot-banner.jpg'

const iframePropsSmall = {
  width: 357,
  height: 150,
  seamless: '',
  scrolling: 'no',
  frameBorder: 0,
  src: bannerImage,
}

const iframePropsWide = {
  width: 735,
  height: 220,
  seamless: '',
  scrolling: 'no',
  frameBorder: 0,
  src: bannerImageWide,
}

export const adSlotSmall = title => (
  <iframe {...iframePropsSmall} title={title} />
)
export const adSlotWide = title => <iframe {...iframePropsWide} title={title} />
